export default "__VITE_ASSET__Ch2sIX0v__"